import clsx from "clsx";

export type LoadingIndicatorSize = "sm" | "md" | "lg";

export interface LoadingIndicatorProps {
    /** スピナーサイズ（デフォルト: md） */
    size?: LoadingIndicatorSize;
    /** 下部に表示するテキスト（デフォルト: "読み込み中..."） */
    label?: string;
    /** 親要素の中央に絶対配置する（親に relative 指定が必要） */
    absoluteCenter?: boolean;
    /** 追加クラス */
    className?: string;
}

const SPINNER_SIZE_CLASS: Record<LoadingIndicatorSize, string> = {
    sm: "w-6 h-6 border-[3px]",
    md: "w-12 h-12 border-[5px]",
    lg: "w-16 h-16 border-[6px]",
};

const LABEL_SIZE_CLASS: Record<LoadingIndicatorSize, string> = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base",
};

const GAP_CLASS: Record<LoadingIndicatorSize, string> = {
    sm: "gap-1.5",
    md: "gap-3",
    lg: "gap-4",
};

export const LoadingIndicator = ({
    size = "md",
    label = "読み込み中...",
    absoluteCenter = false,
    className,
}: LoadingIndicatorProps) => {
    const content = (
        <div className={clsx("flex flex-col items-center", GAP_CLASS[size])}>
            <div
                className={clsx(
                    SPINNER_SIZE_CLASS[size],
                    "border-brand-200 border-t-brand-500 rounded-full animate-spin",
                )}
            />
            {label && <span className={clsx(LABEL_SIZE_CLASS[size], "text-gray-600")}>{label}</span>}
        </div>
    );

    if (absoluteCenter) {
        return <div className={clsx("absolute inset-0 flex items-center justify-center", className)}>{content}</div>;
    }

    return <div className={clsx("w-full h-full flex items-center justify-center", className)}>{content}</div>;
};
